import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { MessageCircle, ChefHat, Eye } from 'lucide-react';
import { mockData } from '../mock';

const catalogItems = [
  {
    id: "polo",
    name: "Polo T-Shirts",
    subtitle: "15 Colors Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/tgzypuso_WhatsApp%20Image%202026-04-14%20at%205.07.20%20PM.jpeg",
    shopTab: "polo",
  },
  {
    id: "roundneck",
    name: "Round Neck T-Shirts",
    subtitle: "24 Colors Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/o02hpmf2_WhatsApp%20Image%202026-04-14%20at%205.14.00%20PM.jpeg",
    shopTab: "roundneck",
  },
  {
    id: "formal-shirts",
    name: "Formal Shirts",
    subtitle: "12 Colors Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/7jwt6twp_WhatsApp%20Image%202026-04-14%20at%204.20.57%20PM.jpeg",
    shopTab: "formal-shirt",
  },
  {
    id: "cargo",
    name: "Cargo Pants",
    subtitle: "5 Colors - Waist 28-44",
    image: "https://customer-assets.emergentagent.com/job_alf-embroidery/artifacts/dmp5dgv6_WhatsApp%20Image%202026-03-15%20at%2010.30.41%20PM.jpeg",
    shopTab: "cargo",
  },
  {
    id: "formal-pants",
    name: "Formal Pants",
    subtitle: "4 Colors Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/540zldo6_WhatsApp%20Image%202026-04-14%20at%204.46.04%20PM.jpeg",
    shopTab: "formal-pants",
  },
  {
    id: "chef-coats",
    name: "Chef Coats",
    subtitle: "8 Styles Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/lo5e1acx_WhatsApp%20Image%202026-04-14%20at%203.52.57%20PM.jpeg",
    shopTab: "chef-coat",
  },
  {
    id: "chef-pants",
    name: "Chef Pants",
    subtitle: "3 Styles Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/1fq3x9oi_WhatsApp%20Image%202026-04-14%20at%204.43.54%20PM.jpeg",
    shopTab: "chef-pants",
  },
  {
    id: "apron",
    name: "Aprons",
    subtitle: "Full & Half - 12 Colors",
    image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/m0i1kq8f_WhatsApp%20Image%202026-04-14%20at%205.36.33%20PM.jpeg",
    shopTab: "apron",
  },
  {
    id: "waistcoat",
    name: "Waistcoat",
    subtitle: "2 Styles Available",
    image: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/1cx04f10_ChatGPT%20Image%20Apr%2014%2C%202026%2C%2004_29_03%20PM.png",
    shopTab: "waistcoat",
  },
  {
    id: "bandana-chef-cap",
    name: "Bandana Chef Cap",
    subtitle: "Multiple Colors",
    image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/ro6hqs50_61rxAoEquvL._AC_UY350_.jpg",
    shopTab: "bandana-chef-cap",
  },
  {
    id: "safety-vest",
    name: "Safety Vest",
    subtitle: "High Visibility",
    image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/gr7j61r0_images%20%286%29.jpg",
    shopTab: "safety-vest",
  },
  {
    id: "hoodie",
    name: "Hoodie",
    subtitle: "Multiple Colors",
    image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/o3rcj0ss_S76c2e881e03b4e95bdd04e82f4e057ceH.avif",
    shopTab: "hoodie",
  },
  {
    id: "cotton-cap",
    name: "Cotton Caps",
    subtitle: "17 Colors Available",
    image: "https://customer-assets.emergentagent.com/job_651ffb38-388c-44ed-a90c-c9f123653714/artifacts/d3b936qa_61sHJLWcEZL._AC_UY350_.jpg",
    shopTab: "cotton-cap",
  },
];

const PoloShirtCatalog = () => {
  const { contact } = mockData;
  const navigate = useNavigate();

  return (
    <section id="catalog" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <Badge className="bg-blue-900 text-white px-4 py-2 text-sm font-semibold mb-4">
            COMPLETE CATALOGUE
          </Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Product Range
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Browse our complete selection of uniforms - polo shirts, t-shirts, cargo pants, chef wear, formal wear & more
          </p>
        </div>

        {/* Product Card Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {catalogItems.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-blue-900 hover:shadow-xl transition-all duration-300 cursor-pointer"
              onClick={() => navigate(`/catalogue?tab=${item.shopTab}`)}
            >
              <div className="aspect-square overflow-hidden bg-slate-50 p-3 flex items-center justify-center">
                {item.image ? (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  />
                ) : (
                  <ChefHat className="w-24 h-24 text-gray-400 group-hover:scale-105 transition-transform duration-300" />
                )}
              </div>
              <div className="p-4 text-center">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.name}</h3>
                <p className="text-sm text-gray-500 mb-3">{item.subtitle}</p>
                <div className="flex items-center justify-center gap-2 text-blue-900 font-semibold text-sm group-hover:text-blue-700">
                  <Eye className="h-4 w-4" />
                  View Details
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PoloShirtCatalog;
